import { render, staticRenderFns } from "./FeedItem.vue?vue&type=template&id=192e53bd&scoped=true&"
import script from "./FeedItem.vue?vue&type=script&lang=js&"
export * from "./FeedItem.vue?vue&type=script&lang=js&"
import style0 from "./FeedItem.vue?vue&type=style&index=0&id=192e53bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192e53bd",
  null
  
)

export default component.exports